// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1vWIf","calendarButtons":"ClockData_calendarButtons__1A7Dx"};